<h1 align="center">LE CENTO TESI: 2017-2024</h1>
<h2> Cos'è "Le cento tesi"?</h2>
<p>De Cifris crede nel crescente ruolo della crittografia nel panorama italiano ed internazionale,
	e promuove iniziative divulgative e volte al community building.
	<br>
	Una di queste attività è la raccolta in un volume di
	100 tesi di Crittografia (e argomenti correlati), <b>Cento Tesi di Crittografia e Codici in Italia 2017-2024</b>.
	Il volume contiene un breve riassunto in italiano di 100 tesi
	dal 2017 al 2024, dando enfasi chiaramente alla <b>crittografia</b>, ma lasciando anche
	spazio ad argomenti collegati, in particolare alla <b>teoria dei codici</b>.
	<br>
	I docenti aderenti alla De Cifris sono invitati a partecipare all'iniziativa contattando gli editori.
</p>
<h2> Come partecipare?</h2>
<p>
	Può partecipare ogni socio De Cifris che abbia prodotto una tesi di argomento vicino alla crittografia dal 2017
	al 2024.
	La partecipazione è gratuita, basta inviare il seguente materiale all'indirizzo
	<a href="mailto:tesi@decifris.it">tesi&#64;decifris.it</a>:
</p>
<ul>
	<li> nome, cognome e data di conseguimento della laurea in questione</li>
	<li> una copia completa della propria tesi per la valutazione della Commissione</li>
	<li> (<i>facoltativo</i>) una propria cover letter, che giustifichi e contestualizzi l'interesse crittografico
		della
		tesi</li>
	<li> (<i>facoltativo</i>) una cover letter del proprio relatore, che commenti il lavoro svolto e descriva
		eventuali
		pubblicazioni derivanti dalla tesi</li>
</ul>
<h2> Perché partecipare?</h2>
<p>
	Vedrete pubblicate <a routerLink="/koine"> nella nostra collana Koine </a> (con DOI) le tesi selezionate
	dalla Commissione.
	<br>
	Le migliori accederanno ad un montepremi di <b>1500.00 EUR</b>.
</p>
<h2> Responsabili </h2>
<h3> Editors </h3>
<ul>
	<li>
		<i> Alessandro De Piccoli</i>, Collaboratore dell’Università degli Studi di Milano
	</li>
	<li>
		<i> Paolo Santini</i>, Università Politecnica delle Marche
	</li>
	<li>
		<i> Ferdinando Zullo</i>, Università degli Studi della Campania "Luigi Vanvitelli"
	</li>
</ul>
<h3> Commissione di valutazione </h3>
<ul>
	<li>
		<i> Antonino Giovanni Alì</i> (IUS/13), Università degli Studi di Trento
	</li>
	<li>
		<i> Fabrizio Barroero</i> (MAT/02), Università di Roma Tre
	</li>
	<li>
		<i> Stelvio Cimato</i> (INF/01), Università degli Studi di Milano
	</li>
	<li>
		<i> Veronica Cristiano</i> (MAT/02), Telsy
	</li>
	<li>
		<i> Clemente Galdi</i> (INF/01), Università degli Studi di Salerno
	</li>
	<li>
		<i> Marco Pedicini</i> (MAT/01), Università di Roma Tre
	</li>
	<li>
		<i> Ottavio Rizzo</i> (MAT/04), Università degli Studi di Milano
	</li>
	<li>
		<i> Lea Terracini</i> (MAT/02), Università di Torino
	</li>
</ul>
<hr>
<h2> Regolamento </h2>
<h3> Date e deadlines</h3>
<ul>
	<li>
		<b>FINE SETTEMBRE 2025:</b>
		invio delle tesi alla Commissione.
	</li>
	<li>
		<b>FINE OTTOBRE 2025:</b>
		la commissione seleziona le tesi da pubblicare.
	</li>
	<li>
		<b>FINE NOVEMBRE 2025:</b>
		invio alla commissione del riassunto della tesi.
	</li>
	<li>
		<b>2026 (data da definirsi):</b>
		pubblicazione del volume.
	</li>
</ul>
<h3> Sottomissione del manoscritto</h3>
<ul>
	<li>La data considerata è quella di effettivo conseguimento della laurea, e deve andare dall'anno 2017 (incluso)
		all'anno 2024 (incluso).</li>
	<li> L'argomento deve essere vicino alla crittografia, non necessariamente di carattere teorico.
		Ad esempio sono benvenute tesi compilative, di giurisprudenza, di ingegneria, di informatica etc. La pertinenza
		verrà valutata dalla Commissione.</li>
	<li>Per chi ha conseguito più di una laurea in questo intervallo, è consentito
		partecipare con più di una tesi.</li>
</ul>
<h3> Valutazione della Commissione</h3>
<ul>
	<li> La Commissione valuterà la pertinenza del contenuto della tesi e provvederà ad individuare le più adatte
		alla pubblicazione.</li>
	<li> La Commissione selezionerà inoltre le tesi più meritevoli in ciascun ambito (PhD, MSc, BSc) per l'assegnazione
		del montepremi di 1.500 EUR. </li>
</ul>
<h3> Sottomissione del riassunto</h3>
<ul>
	<li> Al termine della valutazione, gli autori delle tesi più adatte verranno contattati. Verrà loro richiesto di
		sottomettere un breve riassunto della propria tesi secondo i seguenti limiti:
		<ul>
			<li> massimo 10 pagine formato A5 per tesi di dottorato </li>
			<li> massimo 7 pagine formato A5 per tesi magistrali </li>
			<li> massimo 5 pagine formato A5 per tesi triennali </li>
		</ul>
		Il template verrà fornito dalla Commissione. Formati accettati sono .docx e .tex.
	</li>
	<li> Gli Editori si riservano di poter apportare modifiche minori per garantire che i limiti vengano rispettati.
	</li>
</ul>
<h3> Pubblicazione </h3>
<ul>
	<li> Gli elaborati verranno pubblicati sulla collana Koine di DeCifris Press.</li>
	<li> Agli autori delle tesi pubblicate verrà consegnata una copia della pubblicazione.</li>
</ul>
